import Vue from 'vue'
import Config from './vue.config'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueWechatTitle from 'vue-wechat-title'

import {
  Button,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  List,
  Cell,
  CellGroup,
  PullRefresh,
  Col,
  Row,
  Field,
  Dialog,
  Image as VanImage,
  Icon
} from 'vant';

Vue.use(Button)
    .use(Tabbar)
    .use(TabbarItem)
    .use(Swipe)
    .use(SwipeItem)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(PullRefresh)
    .use(Col)
    .use(Row)
    .use(Field)
    .use(Dialog)
    .use(VanImage)
    .use(Icon);

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

Vue.prototype.$configs = Config;

Vue.use(VueWechatTitle);

router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
}),

Vue.prototype.baseUrl = function () {
  // return 'http://localhost:5001';
  return 'https://www.test.jindianfuwu.com';
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


